<template>
  <div class="nrb">
    <app-NrbHero></app-NrbHero>
    <app-AboutTraining></app-AboutTraining>
    <app-NrbProcess></app-NrbProcess>
    <u-testimonials :items="items" headline="What Our Trainers Say"></u-testimonials>
    <app-NrbPastSessions></app-NrbPastSessions>
  </div>
</template>

<script>
import nrbHero from "../components/nrb/nrbHero";
import aboutTraining from "../components/nrb/nrbAboutTraining";
import nrbProcess from "../components/nrb/nrbProcess";
import nrbPastSessions from "../components/nrb/nrbPastSessions";
export default {
  name: "nrbname",
  components: {
    appNrbHero: nrbHero,
    appAboutTraining: aboutTraining,
    appNrbProcess: nrbProcess,
    appNrbPastSessions: nrbPastSessions
  },
  created() {
    this.Loaded();
  },
  data() {
    return {
      items: [
        {
          title: "Ishraq Dhaly",
          subtitle: "Director, Accounts & Servicing, Magnito Digital",
          body:
            "As a trainer at Upskill, I am in awe of their approach to addressing the skills gap in this market. From identifying the core skills and courses necessary for this market, as well as to identify potential participants and their needs, wants, and desires, to finding the right resources in terms of qualified trainers and mentors to address the needs - Upskill does it all very meticulously. The management is cordial and professional and the facilities are top-notch. Upskill has built a knowledge-centric platform and they package it the proper way, they present it in the best way! I truly am proud to be associated with Upskill",
          image: require("../assets/dhaly.gif")
        },
        {
          title: "Mostafa Didar",
          subtitle: "CTO, Akash",
          body:
            "It has been 2 wonderful months mentoring and training enthusiasts of Data and Machine Learning. There were people in the program who were from different backgrounds (Business, Engineering and Technology) and it was\n" +
            "\n" +
            "outstanding to see all of their collaborative efforts. I had a great time designing content and mentoring them. What impressed me most was their enthusiasm for data, some of them were job holders who came from work to learn about the Art of the DS and ML. Overall I am honored to have shared my skills and thoughts with these people and thanks to Upskill for giving me this opportunity. The total remuneration I had received over the span of two months was 42,000 BDT. Looking forward to future collaborations.",
          image: require("../assets/didar.gif")
        },
        {
          title: "Rafeed Elahi",
          subtitle: "Head of Content, Torun Digital",
          body:
            "I would give Upskill a standing ovation not for giving me such a valuable experience and a platform to teach only, but for how they're shaping up the ecosystem for learners with development courses in various fields. Upskill provided me with constant updates and suggestions, which helped me improve the course material. I also received a lot of prestigious comments from people regarding the course. I am definitely planning to work with Upskill again in the future.",
          image: require("../assets/rafaed.gif")
        }
      ]
    };
  }
};
</script>
